import { useState, useLayoutEffect, useRef, useEffect } from 'react';
import NavigationBarStudentLanding from "../../components/NavigationBarStudentLanding";
import TopHeader from "../../components/TopHeader";
import Footer from "../../components/Footer";
import { getHomePage } from "../../api/initialApis";
import { __courseCardNew, renderCustomCourseCard, filterCourses, selectTimezone } from './react_course_card.js';
import parse from 'html-react-parser';

function MyComponent({ filterCourses }) {
    /*`<div id="custom_course_card_block_qw14xQH"><h1>Our Product<button id="custom_course_card_block_qw14xQH">Click me</button></h1><p class="size-18" style="letter-spacing: 2px">We make shopping way easier and convenient for you</p></div>` */
    const [innerHtml, setInnerHtml] = useState();
    const [elementRendered, setElementRendered] = useState(false);
    const homePage = async() => {
        const response = await getHomePage();
        if (response.data) {
            setInnerHtml(parse(response.data.data.content));
            const custom_course_card_block = document.querySelector('[data-custom-block="custom_course_card_block"]');
            if(custom_course_card_block)
            {
                custom_course_card_block.innerHTML = renderCustomCourseCard();
                setTimeout(() => {
                    setElementRendered(true);
                }, 25);
            }
        }
    }

    useEffect(() => {
        homePage();
    }, []);

    useEffect(() => {
        if (elementRendered) {
            const allCourseButton = document.querySelector("#filterCourses_0");
            const blendedCourseButton = document.querySelector("#filterCourses_1");
            const offlineCourseButton = document.querySelector("#filterCourses_2");
            const upcomingCourseButton = document.querySelector("#filterCourses_3");
            const onlineCourseButton = document.querySelector("#filterCourses_4");
            const selectTimeZone = document.querySelector("#select_time_zone");

            if (allCourseButton) {
                allCourseButton.addEventListener("click", function () { filterCourses(0); 
                // setTimeout(() => {
                    // setElementRendered(true);
                // }, 2000);
                });
            }
            if (blendedCourseButton) {
                blendedCourseButton.addEventListener("click", function () { filterCourses(1); 
                    // setTimeout(() => {
                        // setElementRendered(true);
                    // }, 2000);
                    });
                }
                if (offlineCourseButton) {
                offlineCourseButton.addEventListener("click", () => filterCourses(2));
                }
                if (upcomingCourseButton) {
                upcomingCourseButton.addEventListener("click", () => filterCourses(3));
                }
                if (onlineCourseButton) {
                onlineCourseButton.addEventListener("click", () => filterCourses(4));
                }
                selectTimeZone.addEventListener("click", () => selectTimezone(selectTimeZone));
           
            return () => {
                if (allCourseButton) {
                    allCourseButton.removeEventListener("click", filterCourses);
                }
                if (blendedCourseButton) {
                    blendedCourseButton.removeEventListener("click", filterCourses);
                }
                if (offlineCourseButton) {
                    offlineCourseButton.removeEventListener("click", filterCourses);
                }
                if (upcomingCourseButton) {
                    upcomingCourseButton.removeEventListener("click", filterCourses);
                }
                if (onlineCourseButton) {
                    onlineCourseButton.removeEventListener("click", filterCourses);
                }
                    selectTimeZone.removeEventListener("click", selectTimezone);
                
            }
        }
    }, [elementRendered, filterCourses])

    return <div dangerouslySetInnerHTML = {
        { __html: innerHtml }
    }
    />;
}

function App() {
    return ( 
    <>
        <TopHeader />
        <NavigationBarStudentLanding />
        <MyComponent filterCourses = { filterCourses }/> 
        <Footer />
    </>
    );
}

export default App;